<template>
  <div class=" is-fullwidth">
   
    <div class="is-pulled-right"><select class="input" v-model="limit" style="display:none">
      <option value="">Number of Orders</option>
      <option value="10">10 orders</option>  
      <option value="50">50 orders</option>  
      <option value="100">100 orders</option>  
      <option value="250">250 orders</option>  
      <option value="">Display All Orders</option>  
    </select></div>
     <div class="is-pulled-right"><input class="input" v-model="search" placeholder="search orders ..."/></div>
     
    <div class="buttons">
        
          <button class="button " v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in locations" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
        
        
      </div>
   
    
    <table class="table  is-fullwidth is-size-7 is-striped" id="orderstable">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer;">Order Date
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Garment</th>
          <th>Fabric</th>
          <th>Type</th>
          <th>Qty</th>
          
         
          <th>Week</th>
    	</thead>
    	<tbody>
        <tr v-if="loading === true">
                <td colspan="14" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="14" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
        <template v-for="row in planner_weeks">
            <tr  :key="row.date" class="is-selected">
              <th colspan="14">Week Commencing {{ row.date_formatted }}</th>
            </tr>
            <tr v-for="order in orderedOrders[row.date]" :key="order.id" >
              <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td ><router-link :to="'/printing-cutting/view-order/' + order.ponumber">{{order.ponumber}}</router-link></td>
          <td>{{order.clientname}}</td>
           <td >{{order.orderdate}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.fabric_name}}</td>
          <td>
            <span v-if="order.fully_printed==1">F/P</span>
              <span v-if="order.part_printed==1">P/P</span>
                <span v-if="order.cut_sew==1">C/S</span>

          </td>
          <td>{{ order.total_qty }}</td>
          
              <td>
                <select class="select" required v-model="order.cutting_planner_date" @change="updatePlannerWeek(order)" :disabled="working==true">
                  <option value="">Select Week</option>
                  <option v-for="(week, index2) in planner_weeks" :key="index2" :value="week.date">{{  week.date_formatted }}</option>
                </select>
            </td>
            </tr>
        </template>

		   
            
           
    	</tbody>
    </table>

    <table class="table is-hoverable is-fullwidth" id="orderstableexcel" style="display:none">
    	<thead>
        <tr>
    		<th>PO Number</th>
   	 		<th>Customer</th>
          <th  >Order Date
            
          </th>
          <th >Delivery
           
          </th>
          <th>Garment</th>
          <th>Fabric</th>
          <th>Type</th>
          <th>Qty</th>
          
        </tr>
    	</thead>
    	<tbody>
		    
        
            
            <tr v-for="order in filteredOrders" v-bind:key="'xls' + order.orderID">
         
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
           <td >{{order.orderdate_raw}}</td>
          <td>{{order.deliverydate_raw}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.fabric_name}}</td>
          <td>
            <span v-if="order.fully_printed==1">F/P</span>
              <span v-if="order.part_printed==1">P/P</span>
                <span v-if="order.cut_sew==1">C/S</span>

          </td>
          <td>{{ order.total_qty }}</td>
          
          
             
			</tr>
    	</tbody>
    </table>
    
    <button @click="exportXLS()" style="display:none" class="button is-info" v-if="loading==false">Export to Excel</button>
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      locations: [],
      order_by: 'cutting_planner_date ASC,deliverydate ASC',
      search: '',
      selected_location_id:0,
      limit: '',
      accessToken: '',
      start_date: '',
      planner_weeks: []
    }
  },
   methods: {
      async getOrders() {
        //if(this.selected_location_id > 0)
        //{
          this.loading=true
          OrderService.getCutSewOffshoreOrders(this.accessToken, this.limit, this.order_by)
          .then(
            (orders => {
              this.$set(this, "orders", orders);
              this.loading=false
            }).bind(this)
          );
        //}
        //else{
        //  this.orders = []
        //  this.loading = false
        //}
      },
    
    
    async updatePlannerWeek(order) {
        this.working = true

        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
            cutting_planner_date: order.cutting_planner_date
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    
    async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?cutting=1&restrict_by_user=1").then(
               response => this.locations = response 
            );
      },
      async getPlannerWeeks() {
        UtilityService.getSimpleApiData(this.accessToken, "planner_weeks?cutting=1").then(
               response => this.planner_weeks = response 
            );
      },
      exportXLS() {
      
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstableexcel'), {sheet:"Sheet 1"});
      XLSX.writeFile(wb, 'Printing Overview.xlsx')

    },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(row) {
            //if(  u.artwork_printed_paper == 0) 
           // {
               console.log(row)
              return 1
           // }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     orderedOrders() {
        // Use reduce to organize orders by date
        const organizedOrders =  this.filteredOrders.reduce((result, order) => {
          const date = order.cutting_planner_date;
          if (!result[date]) {
            result[date] = [];
          }
          result[date].push(order);
          return result;
        }, {});

        return organizedOrders
      }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           //this.getLocations();
           this.getPlannerWeeks();
        });
  },
 
  mounted() {
    

    
  },
   watch: {
    
   
  }
}


</script>

